import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const NomenclatorsModule = lazy(loadModule);

export default NomenclatorsModule;
